module.exports = __webpack_public_path__ + "img/histogram-dark-01.3ec95c76.jpg";